import { Component, OnInit } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Router } from '@angular/router';
import { TitleCasePipe } from '@angular/common';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'app-your-new-policies',
  templateUrl: './your-new-policies.component.html',
  styleUrls: ['./your-new-policies.component.css']
})
export class YourNewPoliciesComponent implements OnInit {

  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private router: Router) { }

  ngOnInit() {
    
    
  }

  getPolicies(){
    // this.serviceURLService.notification().subscribe((successData:any) => {
    //   this.notifications = successData.response.notifications;
    // }, errorData => {
    //   console.log("not registered");
    // })
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
  
}
